import { omit } from 'lodash';

export const racingsListGroupedFromResults = (results) => {
  if (!Array.isArray(results)) return [];

  const grouped = {};

  for (const item of results) {
    const regionId = item.RegionId;
    const regionAlias = item.RegionAlias;
    const competitionId = item.CompetitionId;
    const gameId = item.Id;

    if (!regionId || !competitionId || !gameId) continue;

    if (!grouped[regionId]) {
      grouped[regionId] = {
        id: +regionId,
        name: item.RegionName,
        alias: regionAlias,
        competitions: {},
      };
    }

    if (!grouped[regionId].competitions[competitionId]) {
      grouped[regionId].competitions[competitionId] = {
        id: +competitionId,
        name: item.CompetitionName,
        games: [],
        matchId: gameId,
      };
    }

    grouped[regionId].competitions[competitionId].games.push({
      id: gameId,
      start_ts: item.StartTime,
      ...item,
    });
  }

  // Convert to final array
  return Object.values(grouped).map((region) => ({
    ...region,
    competitions: Object.values(region.competitions).map((comp) => omit(
      {
        ...comp,
        games: comp.games
          .filter((game) => !!game?.start_ts)
          .sort((a, b) => a.start_ts - b.start_ts),
      },
      ['game'],
    )),
  }));
};

export const listFilter = (search, regionAlias, groupedData) => {
  if (!search && regionAlias == null) return groupedData;

  const lowerCaseSearch = search?.toLowerCase() ?? '';

  return groupedData.reduce((acc, region) => {
    const matchesRegion = regionAlias != null
      ? String(region.alias).toLowerCase() === String(regionAlias).toLowerCase()
      : true;

    if (!matchesRegion) return acc;

    const filteredCompetitions = region.competitions.filter((competition) => {
      const compName = competition?.name?.toLowerCase() ?? '';
      return search ? compName.includes(lowerCaseSearch) : true;
    });

    if (filteredCompetitions.length > 0) {
      acc.push({
        ...region,
        competitions: filteredCompetitions,
      });
    }

    return acc;
  }, []);
}
